import { useMemo } from "react";
import { useSelector } from "react-redux";
import ReactJson from "react-json-view";
import Accordion from 'react-bootstrap/Accordion';
import { StaticRedirectUrlTypes } from "@iddataweb/idw-common-ui/enums";
import { getRedirectUrlWithoutHostname } from "@iddataweb/idw-common-ui/utils";
import { getLandingPageData } from "@redux/selectors/common-selectors";
import styles from "./static-landing-page.less";

export const StaticLandingPage = () => {
    const landingPageData = useSelector(getLandingPageData);

    const staticLandingPageName = useMemo(() => {
        const trimmedUrl = window.location.href.split("?")[0];
        const urlWithoutHostname = getRedirectUrlWithoutHostname(trimmedUrl);

        switch(urlWithoutHostname) {
            case StaticRedirectUrlTypes.VIEW_ASSERTIONS:
                return "Assertions";
            case StaticRedirectUrlTypes.VIEW_ATTRIBUTES:
                return "Attributes";
            case StaticRedirectUrlTypes.VIEW_ENDPOINT:
                return "Endpoint";
            case StaticRedirectUrlTypes.VIEW_ID_TOKEN:
                return "ID Token";
            case StaticRedirectUrlTypes.VIEW_POLICY_DECISION:
                return "Policy Decision";
            default:
                return "Unknown Static Endpoint";
        }
    }, [window.location.href]);

    return landingPageData ? (
        <div className={styles.staticLandingPage}>
            <h1>View {staticLandingPageName}</h1>
            <Accordion defaultActiveKey={"0"}>
                <Accordion.Item eventKey={"0"}>
                    <Accordion.Header>{"ID Token JSON"}</Accordion.Header>
                    <Accordion.Body>
                        <ReactJson src={landingPageData} name={"idToken"} />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
    ) : null;
};